const SectionHeading = ({
  title,
  description,
}: {
  title: string;
  description?: string;
}) => {
  return (
    <div className="cur-flex cur-flex-col cur-justify-end cur-items-start cur-gap-[8px]">
      <h2 className="cur-text-[28px] cur-font-bold cur-leading-[31.5px] cur-tracking-[-0.56px] cur-text-navy cur-whitespace-pre-wrap">
        {title}
      </h2>
      {description && (
        <p className="cur-text-[14px] cur-font-normal cur-leading-[18.6px] cur-text-subtle">
          {description}
        </p>
      )}
    </div>
  );
};

export { SectionHeading };
